module.exports = __webpack_public_path__ + "img/135b16f6aa05c5b2722e4d66b22776bf.png";